// extracted by mini-css-extract-plugin
module.exports = {"addTocartButton":"AddToCartButton_addTocartButton__kOOVc","outOfStock":"AddToCartButton_outOfStock__75X_i"};